import { useState, useContext, useEffect, JSX } from 'react'
import { Handle, Position, useReactFlow, ReactFlowInstance } from '@xyflow/react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import CodeIcon from '@mui/icons-material/Code';
import CheckIcon from "@mui/icons-material/Check";


function WorkflowIfNode({ id, data }: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();


    function handleShowIfModal(): void {
        const node = reactFlowInstance.getNode(id);
        context.setEditableIfNodeConfiguration(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node if-condition " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" position={Position.Top} >
                <span className="handle-label top">{ "Input" }</span>
            </Handle>

            <div className="node__layout">
                <div className="layout__top">
                    <span className="if-icon" />
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'If Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    { (data['if_type'] !== "undefined" && data['if_type'] === 'Agent') &&
                        <span className="agent_node" title="Agent based if condition" />
                    }
                    { (data['if_type'] !== "undefined" && data['if_type'] === 'Conditional') &&
                        <span className="code_node" title="Conditional if condition">
                            <CodeIcon />
                        </span>
                    }
                    <span className="settings_node nodrag" onClick={ handleShowIfModal }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle
                type="source"
                position={Position.Bottom}
                style={ { left: '25%' } }
                id="true"
            >
                <span className="handle-label bottom" >{ "True" }</span>
            </Handle>
            <Handle
                type="source"
                position={Position.Bottom}
                style={ { left: '75%' } }
                id="false"
                title="False"
            >
                <span className="handle-label bottom" >{ "False" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowIfNode;